import React, { useState } from 'react';
import { Card, Col, Row, Space } from 'antd';
import { Link, useNavigate, useSearchParams } from 'react-router';
import isObject from 'lodash/isObject';
import { useIntl } from 'react-intl';
import { RiArrowLeftLine } from 'react-icons/ri';
import useNavigationSource from '../../../../../app/hooks/useNavigationSource';
import appRoutes from '@/configs/routes';
import handleResponse from '../../../../../lib/handleResponse';
import { BreadCrumbs, IntlMessages, ActionButton } from '@/components';
import DictionariesProvider from '../../../providers/DictionariesProvider';
import FormCreateDictionary from '../../../forms/FormCreateDictionary';
import getFeatureSourceTranslation from '../../../../Featured/utils/getFeatureSourceTranslation';
import { useCreateDictionaryMutation } from '../../../api/dictionariesApiSlice';

const PageDictionaryCreate = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [searchQueryParams] = useSearchParams();
  const [dictionaryErrors, setCreateDictionaryErrors] = useState(null);
  const { urlPrefix, navigationSource } = useNavigationSource();

  const [createLanguage, { isLoading: isUpdateLanguageLoading }] = useCreateDictionaryMutation();

  const multipleSources = searchQueryParams.get('multipleSources') ?? null;

  const handleCreateDictionary = async (values) => {
    createLanguage({ values })
      .unwrap()
      .then(({ data: dictionary }) =>
        handleResponse('success', intl, 'ui-general-created-successfully', [
          () =>
            navigate(
              appRoutes.urlPageTranslationDetails({
                urlPrefix,
                id: dictionary.id,
                source: navigationSource,
                multipleSources,
              }),
              { replace: true },
            ),
        ]),
      )
      .catch((error) =>
        handleResponse(
          'error',
          intl,
          'ui-general-create-failed',
          [
            () => {
              if (isObject(error?.data)) {
                setCreateDictionaryErrors(error.data.errors);
              }
            },
          ],
          error,
        ),
      );
  };

  return (
    <>
      <Row gutter={[32, 32]} justify="space-between" className="hp-mb-12" align="middle">
        <BreadCrumbs
          breadCrumbParent={
            navigationSource ? (
              <Link to={appRoutes.urlPageFeatures({ featureSource: urlPrefix })}>
                <IntlMessages id={getFeatureSourceTranslation(urlPrefix)} />
              </Link>
            ) : null
          }
          breadCrumbParent2={
            <Link to={appRoutes.urlPageDictionaries({ urlPrefix, source: navigationSource, multipleSources })}>
              <IntlMessages id="dictionaries-breadcrumbs" />
            </Link>
          }
          breadCrumbActive={<IntlMessages id="ui-general-create" />}
        />

        <Col md={10} span={24} className="text-end">
          <Space size="middle">
            <ActionButton
              title={intl.formatMessage({ id: 'ui-general-back-to-list' })}
              icon={<RiArrowLeftLine className="hp-mr-8" size={18} />}
              onClick={() => navigate(-1)}
            />
          </Space>
        </Col>
      </Row>

      <Row gutter={[32, 32]}>
        <Col span={24}>
          <Card
            title={<IntlMessages id="dictionaries-create-title" />}
            className="hp-border-color-black-40 hp-card-6"
          >
            <DictionariesProvider>
              <FormCreateDictionary
                formErrors={dictionaryErrors}
                isSubmitting={isUpdateLanguageLoading}
                onSubmit={handleCreateDictionary}
              />
            </DictionariesProvider>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default PageDictionaryCreate;
